module.exports = __webpack_public_path__ + "static/media/home4.69b16501.jpg";